import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton, Tooltip } from '@material-ui/core';
import {
	Brightness4 as DarkIcon,
	Brightness7 as LightIcon
} from '@material-ui/icons';
import { updateUserPreferences } from '../store/actions/modernDashboard.actions';

const useStyles = makeStyles(theme => ({
	iconButton: {
		transition: 'all 0.3s ease',
		'&:hover': {
			transform: 'rotate(180deg)'
		}
	},
	icon: {
		fontSize: 24
	}
}));

const ThemeToggle = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const { themeMode, loading } = useSelector(state => state.dashboard.userPreferences);

	const handleToggle = () => {
		const newTheme = themeMode === 'dark' ? 'light' : 'dark';
		dispatch(updateUserPreferences({ themeMode: newTheme }));
	};

	const isDark = themeMode === 'dark';

	return (
		<Tooltip title={`Switch to ${isDark ? 'light' : 'dark'} mode`}>
			<IconButton
				className={classes.iconButton}
				onClick={handleToggle}
				disabled={loading}
				color="inherit"
			>
				{isDark ? (
					<LightIcon className={classes.icon} />
				) : (
					<DarkIcon className={classes.icon} />
				)}
			</IconButton>
		</Tooltip>
	);
};

export default ThemeToggle;
